/**
 * Job Board filtering and URL management
 */

import multiselectInstances from './multiselect';

export default function jobBoard() {
  // Only run if job board exists on the page
  if (!jQuery('.job-board__table').length) {
    return;
  }

  // Multiselect instances for job board filters
  const jobFunctionMultiselect = multiselectInstances.get('job_function_dropdown');
  const jobIndustryMultiselect = multiselectInstances.get('job_industry_dropdown');
  const jobLevelMultiselect = multiselectInstances.get('job_level_dropdown');
  const jobDivisionMultiselect = multiselectInstances.get('job_division_dropdown');

  /**
   * Update alternating row colors for visible job board rows
   */
  function updateTableRowColors() {
    setTimeout(() => {
      $('.job-board__table-tbody.list').each(function handleUpdateRowColors() {
        $(this).children('.job-board__table-row:visible').each(function handleSetAlternatingBackgroundColor(index) {
          $(this).css('background-color', index % 2 === 0 ? '#FFFFFF' : '#F9F9F9');
        });
      });
    }, 100);
  }

  /**
   * Get URL parameters for job filters
   * @returns {Object} Object containing filter parameters
   */
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    // Older links (and the opportunities block before SS-65) use ?industry= / ?function=.
    const industryParam = params.get('job_industry') || params.get('industry');
    const functionParam = params.get('job_function') || params.get('function');
    const levelParam = params.get('job_level');
    const divisionParam = params.get('job_division');

    return {
      job_function: functionParam ? functionParam.split(',') : [],
      job_industry: industryParam ? industryParam.split(',') : [],
      job_level: levelParam ? levelParam.split(',') : [],
      job_division: divisionParam ? divisionParam.split(',') : [],
      jobs: params.get('jobs') || '',
    };
  }

  /**
   * Update URL with current filter values without page reload
   */
  function updateUrlParams() {
    const params = new URLSearchParams(window.location.search);
    params.delete('industry');
    params.delete('function');

    // Get current filter values
    const selectedJobFunctions = jobFunctionMultiselect.getSelectedOptions();
    const selectedIndustries = jobIndustryMultiselect.getSelectedOptions();
    const selectedJobLevels = jobLevelMultiselect.getSelectedOptions();
    const selectedDivisions = jobDivisionMultiselect.getSelectedOptions();
    const searchText = jQuery('input.search').val();

    const inputNamesAndSelectedOptions = {
      job_function: selectedJobFunctions,
      job_industry: selectedIndustries,
      job_level: selectedJobLevels,
      job_division: selectedDivisions,
    };

    Object.entries(inputNamesAndSelectedOptions).forEach(([inputName, selectedOptions]) => {
      if (selectedOptions.length > 0) {
        params.set(inputName, selectedOptions.join(','));
      } else {
        params.delete(inputName);
      }
    });

    if (searchText) {
      params.set('jobs', searchText);
    } else {
      params.delete('jobs');
    }

    // Update URL without page reload
    const newUrl = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;

    window.history.pushState({}, '', newUrl);
  }

  /**
   * Apply filters to show/hide job rows
   */
  function applyFilters() {
    const selectedJobFunctions = jobFunctionMultiselect.getSelectedOptions();
    const selectedIndustries = jobIndustryMultiselect.getSelectedOptions();
    const selectedJobLevels = jobLevelMultiselect.getSelectedOptions();
    const selectedDivisions = jobDivisionMultiselect.getSelectedOptions();

    // Start with all job rows
    const $allRows = jQuery('.job-board__table-tbody .job-board__table-row');

    // Show all rows initially
    $allRows.show();

    [
      selectedJobFunctions,
      selectedIndustries,
      selectedJobLevels,
      selectedDivisions,
    ].forEach((selectedMultiselectOptions) => {
      if (selectedMultiselectOptions.length > 0) {
        $allRows.filter(':visible').each(function handleMultiSelectFilter() {
          const $row = jQuery(this);
          const hasOption = selectedMultiselectOptions.some((option) => $row.hasClass(option));

          if (!hasOption) {
            $row.hide();
          }
        });
      }
    });

    updateTableRowColors();
  }

  /**
   * Initialize filters from URL parameters
   */
  function initializeFromUrl() {
    const urlParams = getUrlParams();

    const inputNamesAndMultiSelectInstances = {
      job_function: jobFunctionMultiselect,
      job_industry: jobIndustryMultiselect,
      job_level: jobLevelMultiselect,
      job_division: jobDivisionMultiselect,
    };

    Object.entries(inputNamesAndMultiSelectInstances)
      .forEach(([inputName, multiselectInstance]) => {
        if (urlParams[inputName].length > 0) {
          urlParams[inputName].forEach((val) => {
            jQuery(`input[name="${inputName}[]"][value="${val}"]`).prop('checked', true);
            multiselectInstance.updateLabel();
          });
        }
      });

    // Apply filters immediately if they exist in URL
    if (urlParams.job_function.length > 0
        || urlParams.job_industry.length > 0
        || urlParams.job_level.length > 0
    ) {
      applyFilters();
    }
  }

  /**
   * Set up event handlers
   */
  function setupEventHandlers() {
    // Set up multiselect callbacks for job board filtering
    const multiselectCallback = () => {
      applyFilters();
      updateUrlParams();
    };

    [
      jobFunctionMultiselect,
      jobIndustryMultiselect,
      jobLevelMultiselect,
      jobDivisionMultiselect,
    ].forEach((multiselectInstance) => {
      if (multiselectInstance) {
        multiselectInstance.setCallbacks({
          onChange: multiselectCallback,
          onClear: multiselectCallback,
        });
      }
    });

    // Search input handler
    jQuery('input.search').on('input', () => {
      updateUrlParams();
    });

    // Update colors on any click within job board
    jQuery('.job-board').on('click', () => {
      updateTableRowColors();
    });
  }

  /**
   * Initialize the job board
   */
  function init() {
    initializeFromUrl();
    setupEventHandlers();
    updateTableRowColors();
  }

  // Run initialization
  init();
}
